export default __webpack_public_path__ + "static/media/math-multi-select.a5c495bd.svg";